import React from 'react';
import WithAllPropsApp from '@utils/wrappers/WithAllPropsApp';
import Immutable from 'immutable';
import { Icon, IconButton } from '@ts/storybook';

import Link from '@components/Outputs/Link';
import TableV3 from '@modules/tableV3/TableV3';
import h from '@utils/helpers';
import { Select, WrapperEntitySelector } from '@components/Inputs';
import { IconTooltip, Tooltip } from '@components/Outputs';
import { withTranslation } from 'react-i18next';
import { Button, Grid, Typography, Checkbox } from '@ts/storybook';

import act from '@flux/actions/actView';
import { generateSearchEntitySelector } from '@modules/entitySelector/entitySelector.utils';

class ItemTypeHierarchyTab extends React.Component {
  state = {
    sourceItemType: this.props.initialItemType || this.props.values ? Immutable.fromJS(this.props.values) : null, // refactor itemTypes to new architecture....
    memberType: null, // parent or child
    targetItemType: null,
    relation: null,
    deleteMode: false,
  };

  render() {
    const { props, state } = this;
    const { t } = props;
    this._curValues = this.props.values;
    this._fDisabled = this.props.mode === 'view';
    this._fDisabledCandidate = this.props.mode !== 'edit';
    const shouldDisableAddButton =
      !this.state.memberType || !this.state.targetItemType || !this.state.relation || !this.state.sourceItemType;

    let relationFetchData = { itemTypeLid: this._curValues.logicalId };
    let itemTypeSearchComponentProps = { where: {} };
    if (this.state.memberType) {
      relationFetchData.memberTypeToAdd = this.state.memberType;
      if (this.state.memberType == 'parent' && this.state.relation && this.state.relation.parentElementTypeLid) {
        itemTypeSearchComponentProps.where.logicalId = this.state.relation.parentElementTypeLid;
      } else if (this.state.memberType == 'child' && this.state.relation && this.state.relation.childElementTypeLid) {
        itemTypeSearchComponentProps.where.logicalId = this.state.relation.childElementTypeLid;
      }
    }

    return (
      <Grid container direction={'column'} size={12} spacing={2}>
        <Grid container direction={'column'} size={12} spacing={1}>
          <Typography
            variant="h5"
            className='flex'
            text={[
              'Item type hierarchy configuration',
              <IconTooltip info="This configuration will dictate the possible relations between items" />,
            ]}
          />
          <Checkbox
            checked={this._curValues.canHaveParents || false}
            onChangeValue={this.props.onCallbackChange('canHaveParents')}
            label="Can have parents"
            isReadOnly={this._fDisabled}
          />
          <Checkbox
            checked={this._curValues.canHaveChildren || false}
            onChangeValue={this.props.onCallbackChange('canHaveChildren')}
            label="Can have children"
            isReadOnly={this._fDisabled}
          />
        </Grid>
        <Grid container spacing={2} size={12}>
          <Grid size={{ xs: 12 }}>
            <Typography variant="h6" text="Add members to the hierarchy" />
          </Grid>
          <Grid size={{ xs: 12, md: 3 }}>
            <Select
              label={'Type of member'}
              value={this.state.memberType || 'none'}
              onChange={value => this.setState({ memberType: value })}
              isReadOnly={this._fDisabledCandidate}
              options={[
                /*  { label: 'Select member type', value: 'none' }, */
                { label: 'Parent', value: 'parent' },
                { label: 'Child', value: 'child' },
              ]}
            />
          </Grid>
          {this.state.memberType && <Grid size={{ xs: 12, md: 3 }}>
            <WrapperEntitySelector
              label={'Relation'}
              searchComponent={generateSearchEntitySelector('itemRelation')}
              value={state.relation ? state.relation.logicalId : null}
              onChangeEntity={entity => this.setState({ relation: entity })}
              isReadOnly={this._fDisabledCandidate || props.readOnly || !this.state.memberType}
            />
          </Grid>}
          {state.relation && <Grid size={{ xs: 12, md: 3 }}>
            <WrapperEntitySelector
              label={'Candidate item type'}
              searchComponent={generateSearchEntitySelector('itemType')}
              value={state.targetItemType ? state.targetItemType.logicalId : null}
              onChangeEntity={entity => this.setState({ targetItemType: entity })}
              isReadOnly={this._fDisabledCandidate || props.readOnly || !this.state.memberType || !this.state.relation}
            />
          </Grid>}
          {state.targetItemType && <Grid size={{ xs: 12, md: 3 }}>
            <Button
              variant="outlined"
              onClick={this._handleClickAddMember}
              disabled={shouldDisableAddButton}
              label="Add"
              fullWidth
              startIcon={<Icon icon="link" />}
            />
          </Grid>}
        </Grid>
        <Grid size={{ xs: 12 }}>
          <br />
          <Typography
            variant="h6"
            text="Items of following item types will be candidate parents for an item of this item type"
          />
          <Grid size={{ xs: 12 }}>{this.renderCandidateParents()}</Grid>
        </Grid>
        <Grid size={{ xs: 12 }}>
          <br />
          <Typography
            variant="h6"
            text="Items of following item types will be candidate children for an item of this item type"
          />
          {this.renderCandidateChildren()}
        </Grid>
      </Grid>
    );
  }

  getAuxPaths(memberType) {
    let dataPath;
    let keyName;
    let elementTypeKey;
    if (memberType === 'parent') {
      dataPath = 'parentItems';
      keyName = 'candidateParents';
      elementTypeKey = 'candidateParent';
    } else if (memberType === 'child') {
      dataPath = 'childrenItems';
      keyName = 'candidateChildren';
      elementTypeKey = 'elementType';
    }
    const { sourceItemType } = this.state;
    const lid = sourceItemType.logicalId;
    const updateUrl = `/api/v2/itemType/${lid}`;
    const updateCallbackUrl = `/api/itemType/${lid}/${keyName}`;

    return { dataPath, keyName, elementTypeKey, updateUrl, updateCallbackUrl };
  }

  _handleClickAddMember = () => {
    const { targetItemType, memberType, relation } = this.state;

    const { dataPath, keyName, elementTypeKey, updateUrl, updateCallbackUrl } = this.getAuxPaths(memberType);
    const currentCandidates = this.props.data.getIn([dataPath, 'data', 'rows'])?.map(c => ({
      elementTypeLid: c.getIn([elementTypeKey, 'logicalId']),
      elementRelationLid: c.get('relationLid'),
    }));

    const candidate = {
      elementTypeLid: targetItemType.logicalId,
      elementRelationLid: relation.logicalId,
    };
    const newCandidates = currentCandidates.push(candidate);
    const attrs = {};
    attrs[keyName] = newCandidates;

    act.update({
      url: updateUrl,
      dataPath,
      attrs,
      fetch: {
        url: updateCallbackUrl,
        dataPath,
        data: { limit: 5, findAndCount: true },
      },
    });

    this.setState({
      targetItemType: null,
      memberType: null,
      relation: null,
    });
  };

  _handleClickRemoveMember = (memberType, xElementTypeToRemove) => {
    const { dataPath, keyName, elementTypeKey, updateUrl, updateCallbackUrl } = this.getAuxPaths(memberType);

    const currentCandidates = this.props.data.getIn([dataPath, 'data', 'rows'])?.map(c => ({
      elementTypeLid: c.getIn([elementTypeKey, 'logicalId']),
      elementRelationLid: c.get('relationLid'),
    }));
    // find and remove from currentCandidates
    const idx = currentCandidates.findIndex(
      c =>
        c.elementTypeLid === xElementTypeToRemove.getIn([elementTypeKey, 'logicalId']) &&
        c.elementRelationLid === xElementTypeToRemove.get('relationLid')
    );

    const newCandidates = currentCandidates.remove(idx);
    const attrs = {};
    attrs[keyName] = newCandidates;
    //
    act.update({
      url: updateUrl,
      dataPath,
      attrs,
      fetch: {
        url: updateCallbackUrl,
        dataPath,
        data: { limit: 5, findAndCount: true },
      },
    });
  };

  renderCandidateParents() {
    if (!this.state.sourceItemType) return;
    const lid = this.state.sourceItemType.logicalId;

    return (
      <TableV3
        aclId="tsElementType"
        componentId="itemsBase"
        key={`parents_${lid}`}
        title={`${this.props.t('Candidates to parent')}`}
        itemsFetchUrl={`/api/itemType/${lid}/candidateParents`}
        itemsDataPath="parentItems"
        fnFilter={filter => this.setState({ filter })}
        columns={this._getColumns('parent')}
        pkColumn="logicalId"
        fAllowCreate={false}
        fAllowEdit={false}
        fAllowDelete={false}
      />
    );
  }

  renderCandidateChildren() {
    if (!this.state.sourceItemType) return;
    const lid = this.state.sourceItemType.logicalId;
    return (
      <TableV3
        aclId="tsElementType"
        componentId="itemsBase"
        key={`children_${lid}`}
        title={`${this.props.t('Candidates to child')}`}
        itemsFetchUrl={`/api/itemType/${lid}/candidateChildren`}
        itemsDataPath="childrenItems"
        fnFilter={filter => this.setState({ filter })}
        columns={this._getColumns('child')}
        pkColumn="logicalId"
        fAllowCreate={false}
        fAllowEdit={false}
        fAllowDelete={false}
      />
    );
  }

  _getColumns = member => [
    {
      fnLabel: () => this.props.t('Name / ID'),
      name: 'name',
      rawValue: o => (member === 'parent' ? o.get('candidateParent') : o.get('elementType')),
      render: (o, elementType) => {
        const id = elementType.logicalId;
        return (
          <span>
            <span style={_style.name}>{elementType.get('name')}</span>
            <br />
            <Link href={`/itemType/${id}/view`} style={_style.id}>
              {h.getDisplayId(o)}
            </Link>
          </span>
        );
      },
    },
    {
      fnLabel: () => this.props.t('Relation'),
      name: 'relation',
      rawValue: o => o.getIn(['relation', 'name']),
    },

    {
      fnLabel: () => this.props.t('Actions'),
      name: 'relation',
      rawValue: o => o,
      render: o => (
        <IconButton
          onClick={() => {
            this._handleClickRemoveMember(member, o);
          }}
        >
          <Tooltip title={'Remove'}>
            <Icon icon="delete" />
          </Tooltip>
        </IconButton>
      ),
    },
    {
      fnLabel: () => this.props.t('ID'),
      name: 'logicalId',
      fHidden: true,
    },
  ];
}

const _style = {
  outer: {
    marginTop: 0,
  },
  // marginBottom: 70
  id: {
    color: 'gray',
    fontSize: 10,
    whiteSpace: 'nowrap',
  },
  name: {},
};

export default withTranslation()(WithAllPropsApp(ItemTypeHierarchyTab));
